import { apiMutate } from 'service/utils/mutation';
import { useDeliveryZoneMsToken } from 'hooks';
import { GRAPHQL_CLIENT_NAMES } from 'service/constants';
import { DeleteDeliveryZoneInput, DeleteDeliveryZonePayload } from '../../types/generated';
import { deleteDeliveryZoneMutation } from '../../mutations';

type useDeleteDeliveryZoneType = () => ({
  input,
}: {
  input?: DeleteDeliveryZoneInput;
}) => Promise<void | Partial<DeleteDeliveryZonePayload> | { hasError: boolean }>;

const useDeleteDeliveryZone: useDeleteDeliveryZoneType = () => {
  const deliveryZoneMsToken = useDeliveryZoneMsToken();
  return input =>
    apiMutate({
      mutation: deleteDeliveryZoneMutation,
      variables: { input },
      clientName: GRAPHQL_CLIENT_NAMES.DELIVERY_ZONES,
      requestHeaders: { token: deliveryZoneMsToken },
      handler: (res: any) => res,
    });
};

export default useDeleteDeliveryZone;
